import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type AccountTypeType = 'STANDALONE' | 'ROOT' | 'MANAGED'
// FNP-383: PENDING_DELETION is the soft-deleted state (FNP-281). Surfaced in
// the admin Accounts table filter + status badge so admins can find and
// Restore accounts inside the 30-day retention window.
export type AccountStatusType = 'ACTIVE' | 'SUSPENDED' | 'PENDING_DELETION'

export enum AccountType {
    STANDALONE = 'STANDALONE',
    ROOT = 'ROOT',
    MANAGED = 'MANAGED'
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    PENDING_DELETION = 'PENDING_DELETION'
}

export type AccountFormType = {
                                  accountType: AccountTypeType | undefined
                                  accountStatus: AccountStatusType | undefined
                                  managedByUsername?: string
                                  managedBy?: { givenName: string, familyName: string },
                              } & { [key: string]: any }

export type Account = {
                          id: string,
                          sub: string,
                          username: string,
                          email: string,
                          accountType: AccountTypeType | undefined
                          accountStatus: AccountStatusType | undefined
                          customerId: string,
                          createdByUsername?: string,
                          createdBy?: { givenName: string, familyName: string },
                          managedByUsername?: string
                          managedBy?: { givenName: string, familyName: string },
                          // FNP-281 / FNP-383: soft-delete retention metadata. Populated only
                          // when accountStatus = PENDING_DELETION; cleared on restore.
                          deletionRequestedAt?: string,
                          deletionRequestedBy?: string,
                          scheduledHardDeleteAt?: string,
                          created?: string,
                          updated?: string,
                      } & { [key: string]: any }


export interface IAccountTableColumn extends ITableColumn {
    render?: (item: Account) => ReactNode;
}


export type ListAccounts = {
    listAccounts: { items: Account[] }
}

export type GetAccount = {
    getAccount: Account
}

export type CreateAccount = {
    createAccount: Account
}

export type UpdateAccount = {
    updateAccount: Account
}

// FNP-955: deleteAccount returns the soft-deleted Account (matching
// restoreAccount), not an ID. The `string` here tracked the stale schema copy.
export type DeleteAccount = {
    deleteAccount: Account
}

export type RestoreAccount = {
    restoreAccount: Account
}

export type AccountRecordFormProps = {
    record: Account,
    // FNP-555: returns a promise so the drawer can await the mutation before
    // closing. Typed `void` previously, which made `await handleSubmit(...)`
    // a no-op at the type level even though createRecord/updateRecord are async.
    handleSubmit: (values: Account) => void | Promise<unknown>
    handleCancel: () => void
}
